/**
 * @module FieldControls
 */
import { TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a LongText field. Available values will be populated from the FieldSettings.
 */
export const Textarea = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.textarea, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.textarea);

  /*?.replace(/<[^>]*>/g, '') for taking tags from value*/
  const initialState = props.fieldValue || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '';
  const [value, setValue] = useState(initialState);
  const handleChange = event => {
    var _props$fieldOnChange;
    setValue(event.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, event.target.value);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        onChange: handleChange,
        name: props.settings.Name,
        id: props.settings.Name,
        label: props.settings.DisplayName,
        placeholder: props.settings.DisplayName,
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        multiline: true,
        fullWidth: true,
        helperText: props.hideDescription ? undefined : props.settings.Description,
        InputLabelProps: {
          shrink: true
        }
      });
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        component: "div",
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue || localization.noValue));
  }
};
//# sourceMappingURL=textarea.js.map